import * as React from 'react';
import * as sonoraCommonStyles from '../../components/SonoraCommonStyles.scss';
import { Icon } from '@fluentui/react/lib/Icon';
import { PersonaSize } from '@fluentui/react/lib/Persona';
import { ControlIcons } from 'owa-control-icons';
import { CloudIconWithOverlay, getIconCSSForAttachment } from 'owa-file-icon';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import {
    SonoraEntityType,
    SonoraFile,
    SonoraFileSuggestionSourceType,
    SonoraItem,
    SonoraPerson,
    SonoraContact,
    SonoraResultDetailItemsType,
} from 'owa-editor-sonora-types';

export function getIconForSonoraResultsItems(sonoraItem: SonoraItem): JSX.Element {
    switch (sonoraItem?.type) {
        case SonoraEntityType.VivaTopicPerson:
            return (
                <PersonaControl
                    size={PersonaSize.size24}
                    emailAddress={(sonoraItem as SonoraPerson).emailAddress}
                    name={''}
                />
            );
        case SonoraEntityType.StickyNotes:
            return (
                <Icon
                    iconName={ControlIcons.QuickNote}
                    className={sonoraCommonStyles.controlIcon}
                />
            );
        case SonoraEntityType.MeetingTimes:
            return (
                <Icon iconName={ControlIcons.DateTime} className={sonoraCommonStyles.controlIcon} />
            );
        case SonoraEntityType.File:
            const sonoraFile = sonoraItem as SonoraFile;
            switch (sonoraFile.sourceType) {
                case SonoraFileSuggestionSourceType.OneDriveForBusiness:
                case SonoraFileSuggestionSourceType.SharepointOnline:
                    // Cloudy attachment, so use cloudy icon
                    return (
                        <CloudIconWithOverlay
                            fileName={sonoraFile.fileName}
                            contentType={''}
                            isBlocked={false}
                            isFolder={false}
                            embeddedItemClass={''}
                            cloudyIconStyle={sonoraCommonStyles.cloudyIcon}
                            fileIconStyle={sonoraCommonStyles.fileIcon}
                        />
                    );
                case SonoraFileSuggestionSourceType.ClassicAttachment:
                    // Classic attachment, so use regular icon
                    const attachmentIconCSS: string = getIconCSSForAttachment(
                        sonoraFile.fileName,
                        '' /* contentType */,
                        false /* isBlocked */,
                        false /* isFolder */,
                        '' /* embeddedItemClass */
                    ).medium;
                    return <div className={attachmentIconCSS} />;
                default:
                    return <></>;
            }
        case SonoraEntityType.VivaTopicFile:
            // Cloudy attachment, so use cloudy icon
            return (
                <CloudIconWithOverlay
                    fileName={
                        (sonoraItem as SonoraFile).fileName +
                        '.' +
                        (sonoraItem as SonoraFile).fileExtension
                    }
                    contentType={''}
                    isBlocked={false}
                    isFolder={false}
                    embeddedItemClass={''}
                    cloudyIconStyle={sonoraCommonStyles.cloudyIcon}
                    fileIconStyle={sonoraCommonStyles.fileIcon}
                />
            );
        case SonoraEntityType.VivaTopicEntity:
            return (
                <Icon
                    iconName={ControlIcons.NumberSymbol}
                    className={sonoraCommonStyles.controlIcon}
                />
            );
        case SonoraEntityType.Contact:
            return (
                <PersonaControl
                    size={PersonaSize.size24}
                    emailAddress={
                        (sonoraItem as SonoraContact).emailAddresses?.[0]?.EmailAddress ??
                        'fakeEmailForDefaultIcon'
                    }
                    name={''}
                />
            );
        default:
            return <></>;
    }
}

export function getIconForSonoraResultsDetailsItems(itemType: string): JSX.Element {
    switch (itemType) {
        case SonoraResultDetailItemsType.Emails:
            return <Icon iconName={ControlIcons.Mail} className={sonoraCommonStyles.controlIcon} />;
        case SonoraResultDetailItemsType.Phones:
            return (
                <Icon iconName={ControlIcons.Phone} className={sonoraCommonStyles.controlIcon} />
            );
        case SonoraResultDetailItemsType.Addresses:
            return <Icon iconName={ControlIcons.Home} className={sonoraCommonStyles.controlIcon} />;
        default:
            return <></>;
    }
}

export function getIconForSonoraResultsMenu(isCurrentCultureRightToLeft: boolean): JSX.Element {
    return (
        <Icon
            iconName={
                isCurrentCultureRightToLeft ? ControlIcons.ChevronLeft : ControlIcons.ChevronRight
            }
            className={sonoraCommonStyles.chevronIcon}
        />
    );
}
